/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, Grid, Typography } from '@mui/material'
import { CardContent } from '@mui/material'
import { makeStyles } from 'tss-react/mui';

const ProivacyPolicyPage = () => {

    const { classes } = useStyles()
    return (
        <>
            <Grid container spacing={4} style={{ marginTop: '50px' }}>
                <Grid item xs={12} sm={12} md={3} />
                <Grid item xs={12} sm={12} md={6}>

                    <Card>
                        <CardContent>
                            <Typography variant="h2" className={classes.typestyle}>
                                <b>
                                    Privacy Policy

                                </b>
                            </Typography>
                            
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>




        </>
    )
}

const useStyles = makeStyles({ "name": { ProivacyPolicyPage } })(theme => ({
    paper: {
        background: 'rgba(0, 0, 0, 0.5)',
    },
    typestyle: {
        lineHeight: '2.5em!important',
    },
    subtypestyle: {
        lineHeight: '2em!important',
    },
}))

ProivacyPolicyPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledProivacyPolicyPage = ProivacyPolicyPage
const connectedProivacyPolicyPage = connect(mapStateToProps)(styledProivacyPolicyPage)
export { connectedProivacyPolicyPage as ProivacyPolicyPage }
